import React from 'react';
import { WalletIcon, CalendarIcon, ArrowRightIcon, CheckCircleIcon } from 'lucide-react';
import { SettlementData } from '../../utils/dashboardData';
interface SettlementSummaryProps {
  data: SettlementData;
}
const SettlementSummary: React.FC<SettlementSummaryProps> = ({
  data
}) => {
  return <div className="bg-white rounded-2xl shadow-sm border border-slate-200 p-6 h-full flex flex-col" data-id="element-312">
      <div className="flex items-center justify-between mb-6" data-id="element-313">
        <div data-id="element-314">
          <h2 className="text-lg font-bold text-slate-900" data-id="element-315">
            Settlement Summary
          </h2>
          <p className="text-sm text-slate-500 font-medium mt-1" data-id="element-316">
            Your recent and upcoming payouts
          </p>
        </div>
        <button className="text-sm font-semibold text-indigo-600 hover:text-indigo-700 flex items-center transition-colors bg-indigo-50 hover:bg-indigo-100 px-3 py-1.5 rounded-lg" data-id="element-317">
          View All <ArrowRightIcon className="h-4 w-4 ml-1" data-id="element-318" />
        </button>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 flex-1" data-id="element-319">
        <div className="bg-gradient-to-br from-emerald-50 to-teal-50 border border-emerald-100/50 rounded-2xl p-5 flex flex-col justify-center relative overflow-hidden group" data-id="element-320">
          <div className="absolute -right-4 -top-4 w-24 h-24 bg-emerald-500/10 rounded-full blur-2xl group-hover:bg-emerald-500/20 transition-colors" data-id="element-321"></div>
          <div className="flex items-center mb-3 relative z-10" data-id="element-322">
            <div className="p-2 bg-emerald-100 rounded-lg mr-3" data-id="element-323">
              <CheckCircleIcon className="h-5 w-5 text-emerald-600" data-id="element-324" />
            </div>
            <h3 className="text-sm font-bold text-emerald-900" data-id="element-325">
              Today's Settlement
            </h3>
          </div>
          <p className="text-2xl font-bold text-emerald-700 mb-1 relative z-10 tracking-tight" data-id="element-326">
            ₨{data.today.toLocaleString()}
          </p>
          <p className="text-xs font-medium text-emerald-600/80 relative z-10" data-id="element-327">
            Successfully transferred to bank
          </p>
        </div>

        <div className="bg-gradient-to-br from-amber-50 to-orange-50 border border-amber-100/50 rounded-2xl p-5 flex flex-col justify-center relative overflow-hidden group" data-id="element-328">
          <div className="absolute -right-4 -top-4 w-24 h-24 bg-amber-500/10 rounded-full blur-2xl group-hover:bg-amber-500/20 transition-colors" data-id="element-329"></div>
          <div className="flex items-center mb-3 relative z-10" data-id="element-330">
            <div className="p-2 bg-amber-100 rounded-lg mr-3" data-id="element-331">
              <WalletIcon className="h-5 w-5 text-amber-600" data-id="element-332" />
            </div>
            <h3 className="text-sm font-bold text-amber-900" data-id="element-333">
              Upcoming Settlement
            </h3>
          </div>
          <p className="text-2xl font-bold text-amber-700 mb-1 relative z-10 tracking-tight" data-id="element-334">
            ₨{data.upcoming.toLocaleString()}
          </p>
          <p className="text-xs font-medium text-amber-600/80 relative z-10" data-id="element-335">
            Expected tomorrow by 10:00 AM
          </p>
        </div>
      </div>

      <div className="mt-6 pt-5 border-t border-slate-100 grid grid-cols-2 gap-6" data-id="element-336">
        <div className="flex items-start space-x-3" data-id="element-337">
          <div className="p-2 bg-slate-50 rounded-lg mt-0.5" data-id="element-338">
            <CalendarIcon className="h-4 w-4 text-slate-400" data-id="element-339" />
          </div>
          <div data-id="element-340">
            <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider mb-1" data-id="element-341">
              Last Settlement
            </p>
            <p className="text-sm font-bold text-slate-900" data-id="element-342">{data.lastDate}</p>
          </div>
        </div>
        <div className="flex items-start space-x-3" data-id="element-343">
          <div className="p-2 bg-slate-50 rounded-lg mt-0.5" data-id="element-344">
            <WalletIcon className="h-4 w-4 text-slate-400" data-id="element-345" />
          </div>
          <div data-id="element-346">
            <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider mb-1" data-id="element-347">
              Month Total
            </p>
            <p className="text-sm font-bold text-slate-900" data-id="element-348">
              ₨{data.monthTotal.toLocaleString()}
            </p>
          </div>
        </div>
      </div>
    </div>;
};
export default SettlementSummary;